import React, { Component } from 'react';
import './PodcastButton.css'
import {Link} from 'react-router-dom'

class PodcastButton extends Component {
    render() {
	return (
	    <Link to={'/podcasts'}>
		<div className="podcastButton">
		    <div className="content">
			<div className="logo"><img src="/logo-white.svg" alt="Radijski oder" /></div>
			<div className="title">
			    Prisluhni nam
			</div>			
		    </div>
		</div>
	    </Link>
	);
    }
}

export default PodcastButton;



// WEBPACK FOOTER //
// ./src/components/PodcastButton/index.jsx